module.exports = __webpack_public_path__ + "static/media/telegram-no-circle.07c73a8b.svg";